<template>
  <div class="contents">
    <h2>会社連絡 検索</h2>

    <div class="container">
      <template v-if="isLoading">
        <loading v-if="isLoading" :message="'初期化中...'"></loading>
      </template>
      <template v-else>
        <div class="baseinfo">
          <div class="search">
            <h3>検索項目</h3>
            <div class="item-container">
              <div class="item flex data-type">
                <b class="title">検索対象</b>
                <label><input type="radio" name="radioName" v-model="searchItem.dataType" :value="OptionConst.RENRAKU_SERACH_TYPE.RECEIVE"/><span>受信</span></label>
                <template v-if="authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_ALL) || authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_SYOZOKU) 
                  || authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_ALL)">
                  <label><input type="radio" name="radioName" v-model="searchItem.dataType" :value="OptionConst.RENRAKU_SERACH_TYPE.SEND"/><span>送信</span></label>
                </template>
                <template v-if="authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_SYOZOKU) || authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_ALL)">
                  <label><input type="radio" class="input-radio" name="radioName" v-model="searchItem.dataType" :value="OptionConst.RENRAKU_SERACH_TYPE.OTHER"/><span>他の人の送信</span></label>
                </template>
              </div>
              <!-- dummy --><div class="item mob-none"></div><!-- /dummy -->
              <div class="item flex date">
                <b class="title">掲載日</b>
                <date-picker v-model="searchItem.date"></date-picker>
              </div>
              <div class="item flex buka">
                <b class="title">部課</b>
                <select-box :hasBlank="true" :options="option?.buka" v-model="searchItem.buka"></select-box>
              </div>
              <div class="item flex keyword">
                <b class="title">キーワード</b>
                <input-text type="text" v-model="searchItem.keyword"></input-text>
              </div>
              <div class="item flex read">
                <template v-if="searchItem.dataType == OptionConst.RENRAKU_SERACH_TYPE.RECEIVE">
                  <b class="title">既読・未読</b>
                  <select-box :options="OptionConst.RENRAKU_SERACH_READ_OPTION" v-model="searchItem.readType"></select-box>
                </template>
              </div>
            </div>
            
            <div class="btn-container">
              <button type="button" class="btn clear" @click="onClear">クリア</button>
              <button type="button" class="btn primary" @click="onSearch"><i
                  class="fa-solid fa-magnifying-glass"></i>検索</button>
            </div>
          </div>

        </div><!-- /baseinfo -->

        <div class="maininfo">

          <list :isSearching="isSearching" :list="list" :dataType="searchItem.dataType"></list>

        </div><!-- /maininfo -->
      </template>
    </div>


  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted } from 'vue';
import { useInit } from '@/composable/renraku/search/init';
import { useSearch } from '@/composable/renraku/search/search';
import { useRenrakuStore } from '@/store/renraku';
import { useAuthStore } from '@/store/auth'; 
import { RouterConst } from '@/const/Router';
import { DateUtil } from '@/utils/DateUtil';
import OptionConst from "@/const/Option";
import List from '@/components/renraku/search/parts/List.vue'
import { PermissionConst } from '@/const/Permission';

export default defineComponent({
  setup() {

    // 初期化
    const { isLoading, option } = useInit();
    const { isSearching, isError, list, search, searchItem } = useSearch();
    const store = useRenrakuStore();
    const authStore = useAuthStore();

    onMounted(async () => {
      searchItem.value = store.item;
      list.value = await search(searchItem.value)
    })

    const onSearch = async() => {
      store.setItem(searchItem.value);
      list.value = await search(searchItem.value)
    }

    const onClear = () => {
      store.removeItem()
      searchItem.value = store.item
    }

    return {
      isLoading,
      isError,
      list,
      RouterConst,
      OptionConst,
      DateUtil,
      onSearch,
      isSearching,
      onClear,
      searchItem,
      option,
      authStore,
      PermissionConst,
    }
  },
  components: {
    list: List
  }
})
</script>
<style lang="scss" scoped>@import "@scss/components/renraku-search.scss";</style>